const DEFAULT_COMPANY_REDUX_STATE = {
  loading: false,
  company: null,
};

export default DEFAULT_COMPANY_REDUX_STATE;
